{
    "name": "videolectures-project",
    "version": "1.4.13",
    "scripts": {
        "ng": "ng",
        "test": "ng test",
        "build:prod": "ng build --configuration production",
        "build:dev": "ng build --configuration development",
        "start": "node dist/Videolectures-project/server/server.mjs",
        "start:dev": "node dist/Videolectures-project/server/server.mjs",
        "watch": "ng build --watch --configuration local & nodemon --watch dist/Videolectures-project/server/server.mjs --exec 'npm run start:dev'",
        "generate-api": "rm -rf src/app/@generated && openapi-generator-cli generate -g typescript-angular -o src/app/@generated -i ../openapi.yaml -c src/generator-config.json",
        "serve:ssr:Videolectures-project": "node dist/Videolectures-project/server/server.mjs"
    },
    "private": true,
    "dependencies": {
        "@almothafar/angular-signature-pad": "^5.0.1",
        "@angular/animations": "^19.0.5",
        "@angular/cdk": "^19.0.4",
        "@angular/common": "^19.0.5",
        "@angular/compiler": "^19.0.5",
        "@angular/core": "^19.0.5",
        "@angular/forms": "^19.0.5",
        "@angular/platform-browser": "^19.0.5",
        "@angular/platform-browser-dynamic": "^19.0.5",
        "@angular/platform-server": "^19.0.5",
        "@angular/router": "^19.0.5",
        "@angular/ssr": "^19.0.6",
        "@fortawesome/angular-fontawesome": "^1.0.0",
        "@fortawesome/fontawesome-svg-core": "~6.7.2",
        "@fortawesome/free-brands-svg-icons": "^6.7.2",
        "@fortawesome/free-regular-svg-icons": "^6.7.2",
        "@fortawesome/free-solid-svg-icons": "^6.7.2",
        "@grafana/faro-web-sdk": "^1.12.2",
        "@grafana/faro-web-tracing": "^1.12.2",
        "@primeng/themes": "^19.0.1",
        "angular-confirmation-popover": "^7.0.0",
        "buffer": "^6.0.3",
        "compression": "^1.7.5",
        "express": "^4.18.2",
        "marked": "^15.0.0",
        "ngx-markdown": "^19.0.0",
        "ngx-matomo-client": "^6.3.1",
        "ngx-quill": "^27.0.0",
        "ngxtension": "^4.2.0",
        "primeicons": "^7.0.0",
        "primeng": "^19.0.1",
        "quill": "^2.0.3",
        "rollbar": "^2.26.3",
        "rxjs": "~7.8.1",
        "sass": "^1.69.4",
        "swiper": "^8.4.7",
        "tslib": "^2.6.2",
        "zone.js": "~0.15.0"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^19.0.6",
        "@angular/cli": "^19.0.6",
        "@angular/compiler-cli": "^19.0.5",
        "@openapitools/openapi-generator-cli": "^2.15.3",
        "@types/compression": "^1.7.5",
        "@types/express": "^4.17.17",
        "@types/jasmine": "~5.1.1",
        "@types/node": "^20.16.5",
        "jasmine-core": "~5.1.1",
        "karma": "~6.4.2",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage": "^2.2.1",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "~2.1.0",
        "nodemon": "^3.1.9",
        "typescript": "~5.5.4"
    },
    "overrides": {
        "ngx-matomo-client": {
            "@angular/common@": ">=18.0.0",
            "@angular/core@": ">=18.0.0"
        }
    }
}
